import { render } from "./CustomTagsRichText.vue?vue&type=template&id=f42ae27a"
import script from "./CustomTagsRichText.vue?vue&type=script&lang=js"
export * from "./CustomTagsRichText.vue?vue&type=script&lang=js"

import "./CustomTagsRichText.vue?vue&type=style&index=0&id=f42ae27a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__